import React, { ComponentPropsWithoutRef } from "react"
import classNames from "utils/classNames"
import CustomButton, { CustomButtonProps } from "../CustomButton"
import styles from "./styles.module.css"
type ButtonLinkProps = ComponentPropsWithoutRef<"a"> &
  CustomButtonProps & {
    anchorClassName?: string
  }
const ButtonLink = ({
  href,
  className,
  target,
  type,
  download,
  id,
  children,
  rel,
  anchorClassName,
  ...props
}: ButtonLinkProps) => {
  return (
    <a
      rel={rel}
      href={href}
      className={classNames(styles.base, anchorClassName)}
      target={target}
      type={type}
      download={download}
      id={id}
    >
      <CustomButton className={className} {...props}>
        {children}
      </CustomButton>
    </a>
  )
}

export default ButtonLink
